import LegalLayout from "@/components/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout
      testId="terms-page"
      title="Terms of Service"
      updated="December 7, 2026"
    >
      <p>
        These Terms of Service (&quot;Terms&quot;) govern your access to and
        use of the AI Volta website and services (collectively, the
        &quot;Services&quot;). By accessing or using the Services, you agree
        to be bound by these Terms.
      </p>

      <Section title="1. Services">
        <p>
          AI Volta provides AI-powered commercial production, marketing
          automation, AI agent systems, assessments, concierge implementation,
          and website/digital experience services to businesses. Specific
          deliverables, timelines, and fees are defined in a separate written
          engagement letter or statement of work for each client.
        </p>
      </Section>

      <Section title="2. Eligibility">
        <p>
          You must be at least 18 years old and authorized to enter into
          agreements on behalf of any business you represent in order to use
          the Services.
        </p>
      </Section>

      <Section title="3. Free Assessments">
        <p>
          Free AI assessments are provided as a no-obligation consultation.
          Recommendations made during a free assessment are informational and
          do not constitute a binding engagement.
        </p>
      </Section>

      <Section title="4. Intellectual Property">
        <p>
          All content on this website — including copy, design, code, logos,
          and visual assets — is owned by AI Volta or its licensors and is
          protected by intellectual property laws. You may not reproduce,
          distribute, or create derivative works without prior written
          consent. Deliverables produced for clients are governed by the
          relevant statement of work.
        </p>
      </Section>

      <Section title="5. Client Responsibilities">
        <p>
          Clients are responsible for providing accurate information, timely
          feedback, and any required assets, accounts, or credentials needed
          to deliver the Services. Delays caused by missing client
          inputs may impact timelines and fees.
        </p>
      </Section>

      <Section title="6. Payments">
        <p>
          Fees, payment terms, and refund policies are defined in each
          engagement letter. Unless otherwise stated, payments are
          non-refundable once work has commenced.
        </p>
      </Section>

      <Section title="7. Confidentiality">
        <p>
          Each party agrees to keep confidential information shared during the
          engagement strictly confidential and to use it solely for the
          purpose of delivering or receiving the Services.
        </p>
      </Section>

      <Section title="8. Disclaimers">
        <p>
          The Services are provided &quot;as is&quot; without warranties of
          any kind, whether express or implied. We do not guarantee specific
          business outcomes, revenue increases, or rankings.
        </p>
      </Section>

      <Section title="9. Limitation of Liability">
        <p>
          To the maximum extent permitted by law, AI Volta&apos;s aggregate
          liability arising out of or related to the Services will not exceed
          the amounts paid by you to AI Volta in the three (3) months
          preceding the claim.
        </p>
      </Section>

      <Section title="10. Termination">
        <p>
          Either party may terminate an engagement as defined in the
          applicable statement of work. AI Volta may suspend access to the
          Services for any breach of these Terms.
        </p>
      </Section>

      <Section title="11. Governing Law">
        <p>
          These Terms are governed by the laws of the State of Florida,
          without regard to conflict-of-law principles. Any disputes will be
          resolved in the state or federal courts located in Broward County,
          Florida.
        </p>
      </Section>

      <Section title="12. Changes">
        <p>
          We may update these Terms from time to time. Continued use of the
          Services after changes are posted constitutes acceptance of the
          updated Terms.
        </p>
      </Section>

      <Section title="13. Contact">
        <p>
          For questions about these Terms, contact AI Volta via the form on
          our homepage. AI Volta is based in Fort Lauderdale, FL.
        </p>
      </Section>
    </LegalLayout>
  );
}

function Section({ title, children }) {
  return (
    <section>
      <h2 className="font-display text-xl md:text-2xl font-semibold text-white mb-3">
        {title}
      </h2>
      <div className="space-y-3">{children}</div>
    </section>
  );
}
